import { UtilsIdentifier } from "@hotelchamp/common";

import { CheckoutSessionDefaultCaptureMethod } from "../constants/CheckoutSessionDefaultCaptureMethod";
import { CheckoutSessionDefaults } from "../constants/CheckoutSessionDefaults";
import { CheckoutSessionStatus } from "../constants/CheckoutSessionStatus";
import { ICheckoutSessionState } from "../types";

export const defaultEmptyCheckoutSessionStateCreator = (
    overwrites: Partial<ICheckoutSessionState> & { visitor_id: string; property_id: string }
): ICheckoutSessionState => ({
    session_id: UtilsIdentifier.uuid(),
    booking_hash: null,
    status: CheckoutSessionStatus.InProgress,
    capture_method: CheckoutSessionDefaultCaptureMethod,
    has_last_payment_error_been_shown: false,
    expired_at: Date.now() + CheckoutSessionDefaults.SessionTtl,
    ...overwrites,
});

/**
 * isCheckoutSessionStateValid
 * Used when state is being restored.
 * @param state
 * @returns
 */
export const isValidActiveCheckoutSessionState = (state: ICheckoutSessionState) => {
    const hasValidExternalIntentState =
        !state?.external_payment_intent_id ||
        (!!state?.external_payment_intent_id && !!state.external_payment_intent_secret) ||
        !state?.external_setup_intent_id ||
        (!!state?.external_setup_intent_id && !!state.external_setup_intent_secret);

    return !!state && hasValidExternalIntentState && !!state.session_id;
};
